import { CalendarX, CheckCircle } from "@phosphor-icons/react";
import { useMemo } from "react";
import {
  ProjectCardAction,
  ProjectCardActionsBar,
} from "../../../screens/project-details/ProjectCard/ProjectCardActionsBar";

export type MeetingAttendanceActionsProps = {
  isAmbassadorAttend?: boolean;
  onConfirm?: () => void;
  onReschedule?: () => void;
};

export function MeetingAttendanceActions({
  isAmbassadorAttend = false,
  onConfirm,
  onReschedule,
}: MeetingAttendanceActionsProps) {
  const actions: ProjectCardAction[] = useMemo(() => {
    const items: ProjectCardAction[] = [];

    if (isAmbassadorAttend) {
      items.push({
        icon: <CheckCircle size={16} weight="fill" />,
        label: "Attending",
        variant: "confirmed",
        disabled: true,
      });
    } else {
      items.push({
        icon: <CheckCircle size={16} weight="bold" />,
        label: "I'll Attend",
        onClick: onConfirm,
      });
    }

    items.push({
      icon: <CalendarX size={16} weight="bold" />,
      label: "Reschedule",
      onClick: onReschedule,
    });

    return items;
  }, [isAmbassadorAttend, onConfirm, onReschedule]);

  return <ProjectCardActionsBar actions={actions} />;
}
